<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="headingOndernemingen">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseOndernemingen" aria-expanded="false" aria-controls="collapseOndernemingen">
                Ondernemingen
            </button>
        </h2>
        <div id="collapseOndernemingen" class="accordion-collapse collapse" aria-labelledby="headingOndernemingen"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Bij overdracht van ondernemingsvermogen door schenking geldt onder voorwaarden een vrijstelling op grond
                van de bedrijfsopvolgingsregeling (BOR). Deze regeling voorziet in een (gedeeltelijke) vrijstelling van
                schenkbelasting bij voortzetting van de onderneming door de ontvanger.
                <div class="space20"></div>
                Voorwaarde is onder andere dat het
                ondernemingsvermogen minimaal vijf jaar in bezit is geweest van de schenker en dat de ontvanger het
                bedrijf
                ten minste vijf jaar voortzet. Beleggingsvermogen en overtollige liquide middelen zijn uitgesloten. Bij
                overdracht van aandelen moet worden vastgesteld of sprake is van een ‘materiële onderneming’. Complexe
                waarderingsvraagstukken (goodwill, stille reserves) spelen hier vaak een rol.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="headingOndernemingen1">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseOndernemingen1" aria-expanded="false"
                    aria-controls="collapseOndernemingen1">
                BSN/RSIN onderneming
            </button>
        </h2>
        <div id="collapseOndernemingen1" class="accordion-collapse collapse" aria-labelledby="headingOndernemingen1"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Het 'BSN/RSIN onderneming' is het BSN van de natuurlijke persoon die de onderneming drijft of het RSIN
                van de rechtspersoon of samenwerkingsverband.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="headingGoingConcern">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseGoingConcern" aria-expanded="false"
                    aria-controls="collapseGoingConcern">
                Goingconcernwaarde onderneming en schenkbelasting
            </button>
        </h2>
        <div id="collapseGoingConcern" class="accordion-collapse collapse"
             aria-labelledby="headingGoingConcern">
            <div class="accordion-body">
                De <strong>goingconcernwaarde</strong> van een onderneming is de waarde die wordt toegekend aan een
                bedrijf als geheel, in het geval dat het wordt voortgezet.
                Hierbij wordt rekening gehouden met toekomstige winstverwachtingen, lopende contracten, klantenbestand,
                personeel en overige bedrijfsmiddelen.
                <div class="space20"></div>
                Bij een schenking van een onderneming is deze waarde van belang voor de heffing van <strong>schenkbelasting</strong>.
                De Belastingdienst baseert zich op de waarde in het economische verkeer,
                en dat is doorgaans de goingconcernwaarde.
                <div class="space20"></div>
                Een lagere waarde, zoals de liquidatiewaarde, is alleen toepasbaar als aannemelijk is dat het bedrijf
                niet wordt voortgezet. Voor de juiste fiscale afhandeling is het raadzaam
                om een onafhankelijke waardering op te laten stellen.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="headingLiquidatiewaarde">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseLiquidatiewaarde" aria-expanded="false"
                    aria-controls="collapseLiquidatiewaarde">
                Liquidatiewaarde van de onderneming
            </button>
        </h2>
        <div id="collapseLiquidatiewaarde" class="accordion-collapse collapse"
             aria-labelledby="headingLiquidatiewaarde">
            <div class="accordion-body">
                De <strong>liquidatiewaarde</strong> is de waarde van een onderneming of vermogensbestanddeel in het
                geval dat het wordt beëindigd en alle activa afzonderlijk worden verkocht,
                zonder dat er sprake is van voortzetting van de bedrijfsactiviteiten.
                <div class="space20"></div>
                Deze waarde ligt meestal lager dan de <em>goingconcernwaarde</em>, omdat er bij gedwongen verkoop vaak
                minder wordt opgebracht en goodwill of toekomstige winstverwachtingen geen rol spelen.
                <div class="space20"></div>
                De liquidatiewaarde kan van belang zijn bij het bepalen van de schenkbelasting als aannemelijk is dat de
                onderneming na de schenking niet wordt voortgezet.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="headingKoopsom">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseKoopsom" aria-expanded="false"
                    aria-controls="collapseKoopsom">
                Koopsom voor de onderneming
            </button>
        </h2>
        <div id="collapseKoopsom" class="accordion-collapse collapse"
             aria-labelledby="headingKoopsom">
            <div class="accordion-body">
                De ‘koopsom overgedragen aandeel onderneming’ is de koopsom die de begiftigde heeft betaald aan de
                schenker voor het overgedragen aandeel onderneming.
                <div class="space20"></div>
                Indien een onderneming wordt verkocht voor een bedrag lager dan de werkelijke waarde dan is het verschil
                tussen de waarde van het overgedragen aandeel in de onderneming en de koopsom voor het overgedragen
                aandeel in de onderneming een schenking.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="headingBOR">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseBOR" aria-expanded="false"
                    aria-controls="collapseBOR">
                Toepassen Bedrijfsopvolgingsregeling (BOR) bij schenking onderneming
            </button>
        </h2>
        <div id="collapseBOR" class="accordion-collapse collapse"
             aria-labelledby="headingBOR">
            <div class="accordion-body">
                Begiftigde die (een deel van) de onderneming van schenker voortzet, kan
                gebruik maken van de bedrijfsopvolgingsregeling. Begiftigde kan een
                vrijstelling aanvragen voor de schenkbelasting. Er moet wel worden
                voldaan aan de voorwaarden voor de bedrijfsopvolgingsregeling.
                <div class="space20"></div>
                De 'waarde stille reserves' is het verschil tussen de waarde in het economisch verkeer en de boekwaarde
                van een vermogensbestanddeel in het overgedragen deel van de onderneming.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="headingAcuut">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseAcuut" aria-expanded="false"
                    aria-controls="collapseAcuut">
                Acute belastingclaim over ondernemingsvermogen
            </button>
        </h2>
        <div id="collapseAcuut" class="accordion-collapse collapse"
             aria-labelledby="headingAcuut">
            <div class="accordion-body">
                Begiftigde die (een deel van) de onderneming van schenker voortzet, kan
                gebruik maken van de bedrijfsopvolgingsregeling. Begiftigde kan een
                vrijstelling aanvragen voor de schenkbelasting. Er moet wel worden
                voldaan aan de voorwaarden voor de bedrijfsopvolgingsregeling.
                <div class="space20"></div>
                De 'waarde stille reserves' is het verschil tussen de waarde in het economisch verkeer en de boekwaarde
                van een vermogensbestanddeel in het overgedragen deel van de onderneming.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="headingStil">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseStil" aria-expanded="false"
                    aria-controls="collapseStil">
                Waarde stille reserves in overgedragen ondernemingsvermogen
            </button>
        </h2>
        <div id="collapseStil" class="accordion-collapse collapse"
             aria-labelledby="headingStil">
            <div class="accordion-body">
                De 'waarde stille reserves in overgedragen ondernemingsvermogen' is het
                verschil tussen de waarde in het economisch verkeer en de boekwaarde
                van een vermogensbestanddeel in het overgedragen deel van de
                onderneming.
            </div>
        </div>
    </div>


</div>

